<div>

    <div style="margin-bottom: 0.5em">
        ATTENZIONE: confermare l'annullamento della spedizione chiuderà la spedizione con una consegna vuota e genererà un correttivo di discrepanza che riporterà tutti i materiali elencati al magazzino di origine.
    </div>

    <div id="listaMateriali">

            <p-table styleClass="p-datatable-sm" [value]="srcMov.materiali" dataKey="id"
              responsiveLayout="stack">

                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="id">
                                <div class="flex justify-content-between align-items-center">
                                    NMU
                                </div>
                            </th>
                            <th>
                                <div class="flex justify-content-between align-items-center">
                                    descrizione
                                </div>
                            </th>
                            <th>
                                <div class="flex justify-content-between align-items-center">
                                    quantità
                                </div>
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-row>
                        <tr>

                            <td><span class="text-lowercase">{{ row.info.nmu }}</span></td>
                            <td style="width: 100%"><span class="text-lowercase">{{ row.info.descrizione }}</span></td>
                            <td><span class="text-lowercase">

                                {{ row.qt }}

                            </span></td>
                        </tr>
                    </ng-template>
                </p-table>

    </div>

    <p-divider type="solid"></p-divider>

    <div class="dialog_controls">

            <p-button icon="pi pi-times" label="Annulla" class="p-button-text mr-1 row_button" (click)="onActivityCompleted(false)"></p-button>
            <p-button icon="pi pi-check" label="Conferma" class="p-button-text ml-100 row_button" styleClass="p-button-success" (click)="onActivityCompleted(true)" ></p-button>
    </div>
</div>